import { request } from './request'

// 获取 iconfont url
export const getIconfont = _ => {
  return request({
    url: '/getIconfont',
    method: 'GET'
  })
}
